module.exports = __webpack_public_path__ + "./image/426d7e6ee989723f978242d46ba536ef.png";


//////////////////
// WEBPACK FOOTER
// ./images/social-sprites.png
// module id = 8
// module chunks = 0